import React from 'react';
import './styles/global.css';

import useEtude from './hooks/useEtude';
import VuePageEtude from './composants/vues/VuePageEtude';

function App() {
  const etude = useEtude();

  return (
    <div className="app">
      <header className="app-entete">
        <span className="app-entete__marque">i2c - Générateur de documents</span>
        <span className="app-entete__titre">Convention d'étude</span>
      </header>

      <main className="app-contenu">
        <VuePageEtude etude={etude} />
      </main>
    </div>
  );
}

export default App;
